import { style } from '@primeuix/styles/iconfield';
import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-iconfield'
};

export default BaseStyle.extend({
    name: 'iconfield',
    style,
    classes
});
